module.exports = __webpack_public_path__ + "img/front_closure_length.41e2f2cc.png";